import dayjs from "dayjs";

export function getRelativeTime(date?: string | null, referenceDate: Date = new Date()): string {
  if (!date) return "";

  return dayjs(date).from(referenceDate);
}

export function getLocalTime(utcDateTime?: string | null): string {
  if (!utcDateTime) return "";

  const utc = dayjs.utc(utcDateTime);
  if (!utc.isValid()) return "";

  return utc.local().format("YYYY-MM-DD HH:mm:ss");
}

export function getDuration(startDate?: string | null, endDate?: string | null): string {
  if (!startDate || !endDate) return "";

  const start = dayjs(startDate);
  const end = dayjs(endDate);

  if (end.isBefore(start)) throw new Error("End date must be after start date");

  return humanizeDuration(end.diff(start));
}

export function humanizeDuration(duration: number, unit: string = "ms"): string {
  const durationObj: any = dayjs.duration(duration, unit as any);
  const durationKeyArray: Array<string> = Object.keys(durationObj.$d).filter(
    (key) => durationObj.$d[key] > 0 && key !== "milliseconds",
  );
  return durationKeyArray.reduce((acc, curr, index) => {
    const humanizedDuration = dayjs.duration(durationObj.$d[curr], curr as any).humanize();
    if (index === 0) {
      return humanizedDuration;
    } else if (index === durationKeyArray.length - 1) {
      return `${acc} and ${humanizedDuration}`;
    } else {
      return `${acc}, ${humanizedDuration}`;
    }
  }, "0 seconds");
}
